<template>
  <div>
    <p>Monitor and debug your saga workflows with saga diagrams:</p>
    <ul>
      <li><strong>Saga lifecycle</strong> - View the complete history of a saga from start to completion</li>
      <li><strong>State changes</strong> - Track how saga state evolves as messages are processed</li>
      <li><strong>Message correlation</strong> - See which messages initiated and updated the saga</li>
      <li><strong>Timeout tracking</strong> - Monitor saga timeouts and their triggers</li>
    </ul>
  </div>
</template>
